import React, { useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";

const SuccessStoryForm = () => {
  const [form, setForm] = useState({
    bride_name: "",
    groom_name: "",
    user_matrimony_id: "",
    partner_matrimony_id: "",
    email: "",
    marriage_date: "",
    story: "",
  });
  const [errors, setErrors] = useState({});
  const [photo, setPhoto] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [isIdValid, setIsIdValid] = useState({
    user_matrimony_id: true,
    partner_matrimony_id: true,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!localStorage.getItem("accessToken")) {
      toast.error("You must be logged in to submit your success story.");
      return;
    }

    const isUserIdValid = await validateProfileId(
      "user_matrimony_id",
      form.user_matrimony_id
    );
    const isPartnerIdValid =
      form.partner_matrimony_id === "" ||
      (await validateProfileId(
        "partner_matrimony_id",
        form.partner_matrimony_id
      ));

    // Check which one failed and show specific error
    if (!isUserIdValid || !isPartnerIdValid) {
      if (!isUserIdValid && !isPartnerIdValid && form.partner_matrimony_id) {
        toast.error("Both Matrimony IDs are invalid.");
      } else if (!isUserIdValid) {
        toast.error("Your Matrimony ID is not valid.");
      } else if (!isPartnerIdValid && form.partner_matrimony_id) {
        toast.error("Partner's Matrimony ID is not valid.");
      }
      return;
    }

    // Proceed if both valid
    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => data.append(key, value));
    if (photo) data.append("photo", photo);

    try {
      setSubmitting(true);
      await axios.post("/api/success-stories/", data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Your Success Story has been submitted for review!");
      setForm({
        bride_name: "",
        groom_name: "",
        user_matrimony_id: "",
        partner_matrimony_id: "",
        email: "",
        marriage_date: "",
        story: "",
      });
      setPhoto(null);
    } catch (error) {
      console.error(error.response?.data || error.message);
      toast.error("Failed to submit. Please check your details and try again.");
    } finally {
      setSubmitting(false);
    }
  };
  const validateProfileId = async (field, value) => {
    try {
      const res = await axios.get(`/api/check-matrimony-id/${value}/`);
      const valid = res.data.exists;
      setErrors((prev) => ({
        ...prev,
        [field]: valid ? "" : "Not a registered Matrimony ID",
      }));
      setIsIdValid((prev) => ({
        ...prev,
        [field]: valid,
      }));
      return valid;
    } catch (err) {
      console.error("Validation failed:", err);
      return false;
    }
  };

  return (
    <>
      <div className="border-b border-gray-300 mb-4  flex items-baseline gap-4">
        <a
          href="success-story"
          className="text-lg md:text-xl text-gray-800 hover:text-green-600 relative pb-1 text-decoration-none"
        >
          Success Story
        </a>
        <a
          href="upload-success-story"
          target=""
          className="text-md md:text-lg font-semibold text-green-600 text-decoration-none"
        >
          Post your Success Story
        </a>
      </div>
      <div className=" mx-auto px-6 py-10 bg-amber-50">
        <div className=" rounded-3xl p-6 md:p-10 space-y-6">
          <h2 className="text-3xl font-bold text-center text-green-700">
            💍 Share Your Success Story
          </h2>
          <p className="text-center text-gray-600 text-sm md:text-base">
            We love to hear how you found your life partner. Share your journey
            to inspire others on the same path.
          </p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid md:grid-cols-2 gap-4">
              {[
                {
                  label: "Bride Name (Female) *",
                  name: "bride_name",
                  type: "text",
                  placeholder: "Bride Name",
                  required: true,
                },
                {
                  label: "Groom Name (Male) *",
                  name: "groom_name",
                  type: "text",
                  placeholder: "Groom Name",
                  required: true,
                },
                {
                  label: "Your Matrimony ID *",
                  name: "user_matrimony_id",
                  placeholder: "Your Matrimony ID",
                  type: "text",
                  required: true,
                },
                {
                  label: "Partner's Matrimony ID",
                  name: "partner_matrimony_id",
                  placeholder: "Partner Matrimony ID",
                  type: "text",
                },
                {
                  label: "Email *",
                  name: "email",
                  type: "email",
                  placeholder: "Email address",
                  required: true,
                },
                {
                  label: "Marriage Date *",
                  name: "marriage_date",
                  type: "date",
                  required: true,
                },
              ].map((field) => (
                <div key={field.name}>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {field.label}
                  </label>
                  <input
                    type={field.type}
                    name={field.name}
                    placeholder={field.placeholder}
                    value={form[field.name]}
                    onChange={handleChange}
                    onBlur={(e) => {
                      if (
                        ["user_matrimony_id", "partner_matrimony_id"].includes(
                          e.target.name
                        )
                      ) {
                        validateProfileId(e.target.name, e.target.value);
                      }
                    }}
                    required={field.required}
                    className={`w-full border px-3 py-2 rounded-md ${
                      errors[field.name] ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {errors[field.name] && (
                    <p className="text-sm text-red-600 mt-1">
                      {errors[field.name]}
                    </p>
                  )}
                </div>
              ))}
            </div>

            {/* Photo Upload */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Upload a Photo (optional)
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setPhoto(e.target.files[0])}
                className="w-full border border-gray-300 rounded-md px-3 py-2 transition"
              />
              {photo && (
                <div className="mt-3 flex justify-center">
                  <img
                    src={URL.createObjectURL(photo)}
                    alt="Preview"
                    className="w-28 h-28 object-cover rounded-xl border shadow"
                  />
                </div>
              )}
            </div>

            {/* Story */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Your Success Story *
              </label>
              <textarea
                name="story"
                value={form.story}
                onChange={handleChange}
                required
                rows={5}
                placeholder="Tell us about your beautiful journey from meeting to marriage..."
                className="w-full border border-gray-300 rounded-md px-3 py-2 focus:border-green-500 focus:ring-2 focus:ring-green-200 transition"
              ></textarea>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={
                submitting ||
                !isIdValid.user_matrimony_id ||
                (!isIdValid.partner_matrimony_id && form.partner_matrimony_id)
              }
              className={`w-full bg-green-600 text-white font-semibold py-2.5 rounded-md transition hover:bg-green-700 ${
                submitting ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {submitting ? "Submitting..." : "Submit Your Story"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default SuccessStoryForm;
